import React, { useState } from 'react';

// INTERFACES
import { IMenuItemProps } from '../../interfaces/IMenuItem.interface';

// STYLES
import { SubSideBarContainer, SubSideBarItemContainer, ItemSubMenuContainer } from './styles';

interface ISubSideBar {
  onLeave: () => void;
  items: IMenuItemProps[];
}

const SubSideBar: React.FC<ISubSideBar> = ({ onLeave, items }: ISubSideBar) => {
  const [isLeaved, setIsLeaved] = useState(false);

  const onMouseLeave = () => {
    setIsLeaved(true);
    onLeave();
  };

  const renderSubMenu = () => {
    if (items?.length > 0) {
      return items.map((item: IMenuItemProps, idx: number) => {
        const ItemMenu = item.itemMenu;

        return (
          <ItemSubMenuContainer key={idx} itemMenu={ItemMenu} active={item.active}>
            <ItemMenu />
          </ItemSubMenuContainer>
        );
      });
    }
    return <></>;
  };

  return (
    <SubSideBarContainer onMouseLeave={onLeave} isLeaved={isLeaved}>
      <SubSideBarItemContainer>{renderSubMenu()}</SubSideBarItemContainer>
    </SubSideBarContainer>
  );
};

export default SubSideBar;
